/**
 * Typed HTTP error with status code for reliable error handling.
 * Use `instanceof HttpError` and `error.status` instead of string matching.
 */
export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly statusText: string,
  ) {
    super(`HTTP Error: ${status} ${statusText}`);
    this.name = 'HttpError';
  }
}
